import React, { lazy, Suspense } from 'react';

import clientOnly from '../../hoc/clientOnly';

const StarOfDavid = lazy(() =>
  import(/* webpackChunkName: "StarOfDavid" */ './StarOfDavid')
);

const Loader = ({ classes, ...props }) => (
  <div className={classes}>
    <Suspense fallback={null}>
      <StarOfDavid {...props} />
    </Suspense>
  </div>
);

export default clientOnly(Loader);
